export const defaultPageSubTitle = [
    {
        text: 'Change color using ',
        code: '.pagination-*(primary)'
    }
];

export const withDisabledSubTitle = [
    {
        text: 'You can set disabled page with ',
        code: '.disabled '
    },
    {
        text: 'class.'
    }
]

export const activeDisableSubTitle = [
    {
        text: 'Use ',
        code: '.disabled '
    },
    {
        text: 'for links that appear un-clickable and',
        code: ' .active'
    },
    {
        text: ' to indicate the current page.'
    }
]

export const iconPageSubTitle = [{ text: 'Add icons inside the pagination' }];

export const withOutlineSubTitle = [
    {
        text: 'You can use to pagination ',
        code: 'pagination- '
    },
    {
        text: 'class.'
    }
]

export const roundedPageSubTitle = [
    {
        text: 'Used in rounded pagination ',
        code: '.rounded-circle'
    },
    {
        text: ' class.'
    }
]

export const pageAlignSubTitle = [
    {
        text: 'Change the alignment of pagination ',
        code: '.justify-content-center:'
    },
    {
        text: 'class.'
    }
]

export const pageSizeSubTitle = [
    {
        text: 'Pagination size using ',
        code: '.pagination-*'
    },
    {
        text: ' class.'
    }
]

export const defaultPagiData = [
    {
        id: 'Pagination1',
        text: 'Previous'
    },
    {
        id: 'Pagination2',
        text: '1'
    },
    {
        id: 'Pagination3',
        text: '2'
    },
    {
        id: 'Pagination4',
        text: '3'
    },
    {
        id: 'Pagination5',
        text: 'Next'
    }
];

export const withDisabledData = ['1', '2', '...', '9', '10']

export const iconlistData = [
    {
        id: 'Pagination1',
        text: <span aria-hidden="true">«</span>
    },
    {
        id: 'Pagination2',
        text: '1'
    },
    {
        id: 'Pagination3',
        text: '2'
    },
    {
        id: 'Pagination4',
        text: '3'
    },
    {
        id: 'Pagination5',
        text: <span aria-hidden="true">»</span>

    }
]

export const roundedlistData = [
    {
        id: 'Pagination1',
        text: <span aria-hidden="true">«</span>
    },
    {
        id: 'Pagination2',
        text: '1'
    },
    {
        id: 'Pagination3',
        text: '2'
    },
    {
        id: 'Pagination4',
        text: '...'
    },
    {
        id: 'Pagination5',
        text: '20'
    },
    {
        id: 'Pagination6',
        text: <span aria-hidden="true">»</span>

    }
]

export const alignPageData: string[] = ['Previous', '1', '2', 'Next']
export const alignCenterData: string[] = ['Previous', 'I', 'II', 'III', 'Next']
export const alignbottomData: string[] = ['Previous', 'i ', 'ii ', 'iii', 'Next']